// extracted by mini-css-extract-plugin
export default {"alerts":"AlertManager_alerts__avN6r"};